export default function (state,getters,rootState, rootGetters) {
    return rootGetters['dictionaries/paymentOperation/select/list'];
}